export default __webpack_public_path__ + "static/media/icon_search_log.55258393.svg";